import { Base64 } from "js-base64";
import * as gzip from "gzip-js";

export const isValidBase64 = (data: string) => Base64.isValid(data);

export const unzipBase64 = (data: string) => {
    let res: Uint8Array | string = '';
    try {
        const unzippedData = new TextDecoder().decode(Uint8Array.from(gzip.unzip(Base64.toUint8Array(data))));
        res = unzippedData;
    } catch (error) {
        console.error(error);
        res = Base64.toUint8Array(data);
    }
    return res;
}
